// tslint:disable:max-line-length

import React from 'react';

export const OperatorDoesNotContain = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M5.4,14.6c-0.6,0-1.1-0.2-1.5-0.6s-0.6-0.9-0.5-1.5v-2c0-1.4-0.5-1.7-1.5-1.7V7.2c1,0,1.5-0.3,1.5-1.7v-2C3.3,3,3.5,2.4,3.9,2s0.9-0.6,1.5-0.6h2V3H6.7C6.4,3,6.1,3.1,5.9,3.3C5.7,3.5,5.6,3.8,5.6,4.1v1.7c0,1.4-0.4,1.9-1.2,2.2l0,0c0.8,0.2,1.2,0.8,1.2,2.2v1.7c0,0.3,0.1,0.6,0.3,0.8S6.4,13,6.7,13h0.6v1.6H5.4z" />
      <path d="M8.6,14.6V13h0.6c0.3,0,0.6-0.1,0.8-0.3s0.3-0.5,0.3-0.8V10c0-1.4,0.4-1.7,1.2-1.9l0,0c-0.8-0.2-1.2-0.6-1.2-1.9v-2c0-0.8-0.3-1.2-1-1.2H8.7V1.4h2.2c1.3,0,1.8,0.6,1.8,1.9v2.2c0,1.4,0.5,1.7,1.6,1.7v1.6c-1.1,0-1.6,0.3-1.6,1.7v2.2c0,1.2-0.5,1.9-1.8,1.9C10.9,14.6,8.6,14.6,8.6,14.6z" />
      <path d="M13.2,0.4h2.2L3.1,15.6H1L13.2,0.4z" />
    </svg>
  );
};
